import { FC } from 'react';

import { Heart } from 'lucide-react';

import { Button } from '../../components/ui/Button';
import { cn } from '../../utils';

interface Props {
    readonly active: boolean;
    readonly loading: boolean;
    readonly onClick: () => void;
}

export const SellerWishlistFilterButton: FC<Props> = ({
    active,
    loading,
    onClick,
}) => (
    <Button
        type="button"
        variant={active ? 'default' : 'outline'}
        className="h-11 w-full shrink-0 gap-2 rounded-xl px-4 sm:w-auto"
        aria-pressed={active}
        data-testid="seller-wishlist-filter-button"
        disabled={loading}
        onClick={onClick}
    >
        <Heart className={cn('h-4 w-4', active && 'fill-current')} />
        <span>Фільтрувати по списку бажаного</span>
    </Button>
);
